import { render, staticRenderFns } from "./ModalDiagnosticoSocioambientalRepresentante.vue?vue&type=template&id=200779c3&scoped=true&lang=pug"
import script from "./ModalDiagnosticoSocioambientalRepresentante.vue?vue&type=script&lang=js"
export * from "./ModalDiagnosticoSocioambientalRepresentante.vue?vue&type=script&lang=js"
import style0 from "./ModalDiagnosticoSocioambientalRepresentante.vue?vue&type=style&index=0&id=200779c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200779c3",
  null
  
)

export default component.exports